module.exports = __webpack_public_path__ + "apple-icon-76x76.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/apple-icon-76x76.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/apple-icon-76x76.png
// module chunks = 3